import React from "react";
// import { Splitter, SplitterPanel } from 'primereact/splitter';
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";
import { getImageUrl } from "../../utils/commonFunctions";
import placeholderImg from "../../assets/images/placeholder-img.png";

export default function SplitterImgBox({ BeforeImg, style, AfterImg, label }) {
  return (
    <>
      <div className="relative">
        <ReactCompareSlider
          style={style}
          className="border-round-xl "
          itemOne={
            <ReactCompareSliderImage
              src={getImageUrl(BeforeImg)}
              alt="before"
              onError={(e) => (e.target.src = placeholderImg)}
            />
          }
          itemTwo={
            <ReactCompareSliderImage
              src={getImageUrl(AfterImg)}
              alt="after"
              onError={(e) => (e.target.src = placeholderImg)}
            />
          }
        />
        {label ? (
          <>
            <div className="absolute label-spiltter text-green z-2 border-round-xl bg-white px-3 py-1 rounded">
              Before
            </div>
            <div className="absolute label-spiltter text-green z-2 border-round-xl bg-white px-3 py-1 rounded">
              After
            </div>{" "}
          </>
        ) : null}
      </div>
    </>
  );
}
